import React from 'react';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { DocumentaryLibraryCreateContent } from './DocumentaryLibraryCreateContent';

export class DocumentaryLibraryCreateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.DOCUMENTARY_LIBRARY,
            Breadcrumbs.DOCUMENTARY_LIBRARY_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_NUEVO_DOCUMENTO')} breadcrumbs={breadcrumbs}>
                <DocumentaryLibraryCreateContent/>
            </PsPage>
        )
    }
}

DocumentaryLibraryCreateScreen.propTypes = {};

DocumentaryLibraryCreateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/create/DocumentaryLibraryCreateScreen.jsx